// IJSS IT Solutions Pvt. Ltd. - Corporate Website Data
// Real company data from IJSS Technologies (ijsstech.com)

export const companyInfo = {
  name: "IJSS IT Solutions Pvt. Ltd.",
  tagline: "SAP Master Data Governance-First Consulting",
  description: "IJSS IT Solutions Pvt. Ltd. is a SAP Master Data Governance-first consulting company. SAP MDG is our primary and dominant specialization, supported by select SAP, software engineering, and technology services that enable MDG-led transformation programs.",
  framework: "MASTERDATA NOW",
  frameworkTrademark: "MASTERDATA NOW\u2122",
  emails: {
    info: "info@ijssitsolutions.com",
    sales: "sales@ijssitsolutions.com"
  }
};

export const primaryServices = [
  {
    id: 1,
    title: "SAP Master Data Governance Consulting",
    description: "Strategic advisory and hands-on consulting for SAP MDG implementations, assessments, and governance optimization across enterprise landscapes."
  },
  {
    id: 2,
    title: "SAP MDG Implementation & Support",
    description: "End-to-end MDG implementation services including configuration, data modeling, workflow design, and phased rollout management with ongoing support."
  },
  {
    id: 3,
    title: "SAP MDG Audit, Risk Assessment & Remediation",
    description: "Comprehensive audit of existing MDG implementations, risk identification, compliance gap analysis, and structured remediation programs."
  },
  {
    id: 4,
    title: "SAP MDG AMS (L2-L4 Support)",
    description: "Application management services covering incident resolution, change management, enhancements, and ongoing governance optimization."
  },
  {
    id: 5,
    title: "SAP MDG Workflow, BRF+ & Data Quality Governance",
    description: "Governance for workflow configurations, BRF+ rule management, DRF/MDI distribution, data quality monitoring, and replication controls."
  },
  {
    id: 6,
    title: "SAP S/4HANA Data & MDG Migration Governance",
    description: "Data governance frameworks for S/4HANA migrations, data quality assurance, cutover governance, and post-migration stabilization."
  }
];

export const secondaryServices = [
  {
    id: 1,
    title: "SAP S/4HANA Implementation & Support",
    description: "Implementation and support for SAP S/4HANA environments aligned with MDG governance requirements."
  },
  {
    id: 2,
    title: "ECC to S/4HANA Migration",
    description: "System conversion from SAP ECC to S/4HANA with integrated MDG governance throughout the transition."
  },
  {
    id: 3,
    title: "SAP Fiori Implementation & Customization",
    description: "Fiori application implementation for MDG workflows, approvals, and S/4HANA user experiences."
  },
  {
    id: 4,
    title: "SAP Integration with Legacy Systems",
    description: "Integration services connecting SAP with legacy and non-SAP systems, coordinated with MDG governance controls."
  },
  {
    id: 5,
    title: "SAP Cloud Solutions",
    description: "Cloud deployment and migration services for SAP environments with governance and security alignment."
  },
  {
    id: 6,
    title: "SAP Analytics & Automation",
    description: "Analytics, reporting, and automation capabilities deployed to enhance MDG quality, controls, and monitoring."
  }
];

export const engagementModels = [
  {
    id: 1,
    title: "Specialist Sub-Contractor to SAP System Integrators",
    description: "IJSS IT Solutions partners with SAP system integrators as a specialist sub-contractor for MDG workstreams. This model provides access to dedicated MDG expertise without diverting core resources, reducing project risk and improving delivery quality.",
    benefits: [
      "Access to dedicated MDG specialists",
      "Reduced project risk on governance workstreams",
      "Accelerated delivery timelines",
      "Consistent governance standards"
    ]
  },
  {
    id: 2,
    title: "Audit-to-Execution Partner for Big-4 and Advisory Firms",
    description: "IJSS IT Solutions serves as an execution partner for advisory firms conducting SAP MDG audits or assessments. Following audit findings, we provide implementation support to address identified gaps and stabilize MDG environments.",
    benefits: [
      "Seamless transition from audit to remediation",
      "Technical depth to support advisory recommendations",
      "Accountability for execution outcomes",
      "Structured governance improvement programs"
    ]
  },
  {
    id: 3,
    title: "Direct MDG Governance Partner for Enterprises",
    description: "For enterprises seeking direct engagement, IJSS IT Solutions provides end-to-end MDG governance services with founder-led accountability and hands-on expertise from assessment through stabilization.",
    benefits: [
      "Direct access to senior consultants",
      "Founder-led engagement accountability",
      "Long-term governance partnership",
      "Customized delivery approach"
    ]
  }
];

export const industries = [
  {
    id: 1,
    name: "Pharmaceuticals",
    description: "Regulated material master governance, batch management controls, vendor qualification workflows, and compliance-aligned data governance for GxP environments."
  },
  {
    id: 2,
    name: "Automotive",
    description: "Material master governance, BOM hierarchy management, supplier master consolidation, and plant-level data harmonization for automotive manufacturing."
  },
  {
    id: 3,
    name: "Energy & Utilities",
    description: "Asset master governance, equipment hierarchy management, maintenance master data, and supplier master consolidation for complex operational landscapes."
  },
  {
    id: 4,
    name: "FMCG & Distribution",
    description: "Product master governance, customer master harmonization, distribution channel data management, and supply chain data governance."
  },
  {
    id: 5,
    name: "Government & Public Sector",
    description: "Vendor master governance, contract and supplier data management, citizen master data, and compliance-aligned governance for public sector entities."
  },
  {
    id: 6,
    name: "Technology",
    description: "Product master governance, customer and partner data management, and data governance supporting technology sector operations."
  },
  {
    id: 7,
    name: "Manufacturing",
    description: "Material master governance, asset maintenance data, procurement master data, and operational data harmonization for discrete and process manufacturing."
  },
  {
    id: 8,
    name: "Retail",
    description: "Article master governance, vendor and supplier master management, store location data, and customer master consolidation across retail operations."
  }
];

// Real clients from ijsstech.com
export const clients = [
  {
    name: "KPMG",
    logo: "https://www.ijsstech.com/logos/kpmg.svg",
    type: "Big-4"
  },
  {
    name: "Deloitte",
    logo: "https://www.ijsstech.com/logos/deloitte.svg",
    type: "Big-4"
  },
  {
    name: "Infosys",
    logo: "https://www.ijsstech.com/logos/Infosys_logo.svg",
    type: "System Integrator"
  },
  {
    name: "Birlasoft",
    logo: "https://www.ijsstech.com/logos/birla.jpg",
    type: "System Integrator"
  },
  {
    name: "British Council",
    logo: "https://www.ijsstech.com/logos/bc.svg",
    type: "Enterprise"
  },
  {
    name: "ADNOC",
    logo: "https://www.ijsstech.com/logos/adnoc.png",
    type: "Enterprise"
  },
  {
    name: "Edge Abu Dhabi",
    logo: "https://www.ijsstech.com/logos/edge.svg",
    type: "Enterprise"
  },
  {
    name: "Lipton",
    logo: "https://www.ijsstech.com/logos/lipton.svg",
    type: "Enterprise"
  },
  {
    name: "Indian Army",
    logo: "https://www.ijsstech.com/logos/army.svg",
    type: "Government"
  },
  {
    name: "Croda",
    logo: "https://www.ijsstech.com/logos/croda.svg",
    type: "Enterprise"
  },
  {
    name: "Thoucentric",
    logo: "https://www.ijsstech.com/logos/thou.png",
    type: "Consulting"
  },
  {
    name: "Prozia Management Consulting",
    logo: "https://www.ijsstech.com/logos/prozia.png",
    type: "Consulting"
  },
  {
    name: "Truspeq Consulting",
    logo: "https://www.ijsstech.com/logos/trus.jpeg",
    type: "Consulting"
  }
];

// Real testimonials from ijsstech.com
export const testimonials = [
  {
    id: 1,
    company: "Pfizer",
    quote: "IJSS IT Solutions helped us optimize our SAP MDG and S/4HANA processes, ensuring smoother data governance and integration. Their expertise was instrumental in the success of our project implementation."
  },
  {
    id: 2,
    company: "Croda",
    quote: "The SAP MDG implementation was a success, thanks to the exceptional leadership from IJSS IT Solutions. Their strategic approach and precise execution helped us integrate complex data models seamlessly."
  },
  {
    id: 3,
    company: "Applied Materials",
    quote: "The team at IJSS IT Solutions played a key role in upgrading our SAP MDG systems. Their expertise in data migration and configuration helped streamline our operations efficiently."
  }
];

// Real team members from ijsstech.com
export const teamMembers = [
  {
    id: 1,
    name: "Parveen Kaur",
    role: "SAP MDG & S/4HANA Practice Lead",
    description: "SAP Certified Consultant with over 15 years of experience specializing in SAP MDG and S/4HANA solutions. Parveen has successfully led multiple high-impact global projects, driving digital transformation in enterprises across various industries. With deep expertise in data governance, migration strategies, and system integration, she has helped organizations optimize their SAP environments, streamline operations, and achieve scalable solutions.",
    expertise: ["SAP MDG", "S/4HANA", "Data Governance", "Migration Strategies", "System Integration"]
  },
  {
    id: 2,
    name: "Mandeep Singh",
    role: "Cloud & Technology Lead",
    description: "Cloud computing and technology expert with over 8 years of experience delivering solutions across industries. Specializing in scalable cloud architectures and technology-driven solutions, Mandeep has a strong track record of building secure and high-performance platforms using AWS, Azure, and Google Cloud.",
    expertise: ["AWS", "Azure", "Google Cloud", "Cloud Architecture", "Infrastructure"]
  },
  {
    id: 3,
    name: "Zubair Sofi",
    role: "IT Infrastructure Lead",
    description: "IT and cloud solutions expert with over 10 years of experience, specializing in Microsoft 365, Azure, and IT Infrastructure Management. His skills encompass networking, security, and enterprise support, ensuring robust, scalable, and secure solutions for clients.",
    expertise: ["Microsoft 365", "Azure", "IT Infrastructure", "Security", "Networking"]
  }
];

export const governanceAreas = [
  {
    id: 1,
    title: "Audit-First Delivery Approach",
    description: "All engagements begin with a structured assessment of the current MDG landscape. This audit-first approach ensures recommendations are evidence-based and remediation efforts target actual governance gaps."
  },
  {
    id: 2,
    title: "Governance, Traceability & Evidence-Driven Controls",
    description: "We implement governance frameworks providing full traceability of master data changes, approval workflows, and control mechanisms supporting internal audit requirements and regulatory compliance."
  },
  {
    id: 3,
    title: "SAP S/4HANA Transformation Alignment",
    description: "MDG governance is designed to align with and support SAP S/4HANA transformation programs. Data quality, migration governance, and post-go-live stabilization ensure successful adoption."
  },
  {
    id: 4,
    title: "Suitability for Regulated Environments",
    description: "For clients in regulated industries, we provide governance frameworks addressing compliance requirements including audit trails, segregation of duties, and change control procedures."
  }
];

export const aboutContent = {
  headline: "SAP Master Data Governance-First Consulting",
  intro: "IJSS IT Solutions Pvt. Ltd. is a SAP Master Data Governance-first consulting company. SAP MDG is our primary and dominant specialization across all engagements.",
  paragraphs: [
    "Unlike generalist SAP consultancies, IJSS IT Solutions has chosen to lead with SAP Master Data Governance. This MDG-first positioning enables deep technical proficiency, consistent delivery quality, and the ability to address complex governance challenges requiring focused expertise.",
    "The company also delivers select SAP services, software engineering, automation, analytics, and cloud capabilities. These supporting services are deployed only when they strengthen, extend, or operationalize MDG-led and SAP S/4HANA transformation programs. They are never positioned as primary offerings.",
    "Our team brings over 15 years of combined SAP MDG experience, having successfully delivered projects for global enterprises including pharmaceutical companies, manufacturing conglomerates, government entities, and Fortune 500 organizations.",
    "IJSS IT Solutions operates with a founder-led model where senior consultants maintain direct engagement accountability. This approach ensures client engagements receive hands-on attention from experienced practitioners rather than delegation to junior resources.",
    "IJSS IT Solutions does not sell software products. All delivery is consulting-based, covering governance assessments, implementation, audit remediation, stabilization, and application management services. The MASTERDATA NOW\u2122 framework provides a structured methodology for all MDG engagements."
  ]
};

export const footerContent = {
  legal: "IJSS IT Solutions Pvt. Ltd. is a SAP Master Data Governance-first consulting company. MASTERDATA NOW\u2122 is a SAP MDG governance framework delivered by IJSS IT Solutions Pvt. Ltd.",
  copyright: `\u00A9 ${new Date().getFullYear()} IJSS IT Solutions Pvt. Ltd. All rights reserved.`
};
